import { FileText, Droplets, Paintbrush, CheckCircle2, ThumbsUp } from "lucide-react";

const steps = [
  {
    icon: FileText,
    title: "Kostnadsfri besiktning",
    description: "Vi kommer ut och inspekterar din fasad helt utan kostnad. Du får en professionell bedömning av vad som behöver göras.",
  },
  {
    icon: FileText,
    title: "Tydlig offert",
    description: "Baserat på besiktningen får du en detaljerad offert med fast pris. Inga dolda kostnader – du vet exakt vad det kostar.",
  },
  {
    icon: Droplets,
    title: "Grundligt förarbete",
    description: "Vi tvättar, skrapar och grundar fasaden noggrant. Detta är nyckeln till ett resultat som håller i många år.",
  },
  {
    icon: Paintbrush,
    title: "Professionell målning",
    description: "Med rätt färg och teknik för just din fasadtyp målar vi med precision. Vi använder endast kvalitetsprodukter.",
  },
  {
    icon: ThumbsUp,
    title: "Slutkontroll & nöjd kund",
    description: "Innan vi lämnar går vi igenom allt tillsammans. Du ska vara helt nöjd – det är vår garanti.",
  },
];

export default function ProcessSection() {
  return (
    <section className="section-padding bg-white" data-testid="process-section">
      <div className="container mx-auto max-w-4xl">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#b91c1c]">
            Så fungerar det
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
            Så går fasadmålningen till
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            En trygg och tydlig process från start till mål.
          </p>
        </div>

        {/* Timeline */}
        <div className="space-y-0">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative flex gap-6 pb-12 last:pb-0"
              data-testid={`process-step-${index}`}
            >
              {/* Timeline line */}
              {index < steps.length - 1 && (
                <div className="absolute left-6 top-14 bottom-0 w-0.5 bg-slate-200" />
              )}
              
              {/* Icon */}
              <div className="relative z-10 w-12 h-12 bg-[#b91c1c] rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
                <step.icon className="w-5 h-5 text-white" />
              </div>
              
              {/* Content */}
              <div className="flex-1 pt-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-sm font-semibold text-[#b91c1c]">Steg {index + 1}</span>
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
